// extracted by mini-css-extract-plugin
export default {"header":"MobileHeaderModalHeader_header__OWXWV","button":"MobileHeaderModalHeader_button__H4pWB"};